export default "__VITE_ASSET__CfwQShYB__"